import { getName, OntologyType } from "core/model/utils/ontologies";
import { useGetOntologies } from "core/model/utils/ontologies/hooks";
import CheckboxGroup, {
  CheckboxGroupBaseProps,
} from "ds_legacy/components/CheckboxGroup";
import { getOrderedItems } from "ds_legacy/components/ChipGroup";
import { CSSProperties } from "react";
import { useTranslations } from "translations";

export type OntologyCheckboxGroupProps = CheckboxGroupBaseProps & {
  captions?: AnyObject;
  labelStyle?: CSSProperties;
  order?: AnyObject;
  required?: boolean;
  sort?: boolean;
  type: OntologyType;
};

export function useOntologyCheckboxGroup({
  captions,
  order,
  sort,
  type,
}: Pick<OntologyCheckboxGroupProps, "captions" | "sort" | "type" | "order">) {
  const getOntologies = useGetOntologies();
  const values = getOntologies({ sort, type });
  const sortedValues = getOrderedItems(order, values);

  return sortedValues.map((item) => ({
    id: item.value,
    label: item.name,
    RadioCaption:
      captions &&
      Object.keys(captions).filter((key: ToType) => key == item.value)
        .length === 1
        ? captions[item.value]
        : undefined,
  }));
}

export default function OntologyCheckboxGroup({
  captions,
  elementName,
  exclude,
  formControlStyle,
  include,
  label,
  labelStyle,
  labelWrapperStyle,
  order,
  required,
  sideMutation,
  sort,
  type,
  wrapperStyle,
}: OntologyCheckboxGroupProps) {
  const translations = useTranslations();
  const items = useOntologyCheckboxGroup({ captions, order, sort, type });

  return (
    <CheckboxGroup
      elementName={elementName}
      exclude={exclude}
      formControlStyle={formControlStyle}
      include={include}
      items={items}
      label={label != null ? label : getName(type, translations)}
      labelStyle={labelStyle}
      labelWrapperStyle={labelWrapperStyle}
      required={required}
      sideMutation={sideMutation}
      wrapperStyle={wrapperStyle}
    />
  );
}
